import AgentDetails from "./routes/Agents/AgentDetails";
import Agents from "./routes/Agents/Agents";
import AgentTransactions from "./routes/Agents/AgentTransactions";
import NewAgent from "./routes/Agents/NewAgent";
import Commissions from "./routes/Commissions/Coordinator-Commission";
import AgentCustomers from "./routes/Customers/AgentCustomers";
import Dashboard from "./routes/Dashboard/Dashboard-Aggregator";
import Logs from "./routes/Logs/Logs";
import Notifications from "./routes/Notifications/Notifications";
import AssignedPos from "./routes/POS/AssignedPos";
import POS from "./routes/POS/Coordinator-POS";
import POSDetails from "./routes/POS/POSDetails";
import PosTransactionDetails from "./routes/POS/PosTransactionDetails";
import RecommendPos from "./routes/POS/RecommendPos";
import Settings from "./routes/Settings/Settings";
import AgentTellers from "./routes/Tellers/AgentTellers";
import AgentTerminals from "./routes/Terminals/AgentTerminals";
import TransactionDetails from "./routes/Transactions/TransactionDetails";
import Transactions from "./routes/Transactions/CoordinatorTransaction";
import MyTransactions from "./routes/MyTransactions/MyTransactions";
import MyTransactionDetails from "./routes/MyTransactions/MyTransactionDetails";
import LogsDetails from "./routes/Logs/LogsDetails";
import ResetPassword from "./routes/ResetPassword/ResetPassword";
import ResetPin from "./routes/ResetPin/ResetPin";
import PosTransactions from "./routes/POS/POSTransactions";
import Admin from "./routes/Admin/Admin";
import Aggregators from "./routes/Aggregators/Aggregators";
import AggregatorDetails from "./routes/Aggregators/AggregatorDetails";
import FloatFinance from "./routes/FloatFinance/FloatFinance";
import FloatDetails from "./routes/FloatFinance/FloatDetails";
import UpdateAgent from "./routes/Agents/updateAgent";
import Location from "./routes/location/locations";
import LocationDetails from "./routes/location/locationDetails";
import PerformanceChart from "./routes/performanceChart/performanceChart";
import AddAdmin from "./routes/Admin/addAdmin";
import EditAdmin from "./routes/Admin/editAdmin";
import NewAggregators from "./routes/Aggregators/newAggregator";

export const CoordinatorRoutes = [
  {
    name: "Dashboard",
    icon: "bar_chart",
    path: "/dashboard",
    Component: Dashboard,
    forNav: true,
    hasAccess: true,
  },
  {
    name: "POS",
    icon: "mail_outline",
    path: "/pos",
    Component: POS,
    forNav: true,
    hasAccess: true,
  },
  {
    name: "Recommend POS",
    icon: "mail_outline",
    path: "/pos/recommend",
    Component: RecommendPos,
    forNav: false,
    hasAccess: true,
  },

  {
    name: "Assigned POS",
    icon: "mail_outline",
    path: "/pos/assigned",
    Component: AssignedPos,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "POS Details",
    icon: "mail_outline",
    path: "/pos/details/:id",
    Component: POSDetails,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Reset Transaction PIN",
    icon: "mail_outline",
    path: "/account/reset-pin",
    Component: ResetPin,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Transactions",
    icon: "analytics",
    path: "/transactions",
    Component: Transactions,
    forNav: true,
    hasAccess: true,
  },
  {
    name: "Pos Transactions",
    icon: "analytics",
    path: "/pos/transactions",
    Component: PosTransactions,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Reset Password",
    icon: "analytics",
    path: "/account/reset",
    Component: ResetPassword,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Transactions Details",
    icon: "analytics",
    path: "/transactions/details/:id",
    Component: TransactionDetails,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "POSTransactions Details",
    icon: "analytics",
    path: "/pos-transactions/:id",
    Component: PosTransactionDetails,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Commissions",
    icon: "receipt",
    path: "/commissions",
    Component: Commissions,
    forNav: true,
    hasAccess: true,
  },

  {
    name: "Agents",
    icon: "person",
    path: "/agents",
    Component: Agents,
    forNav: true,
    hasAccess: true,
  },
  {
    name: "Float/Finance",
    icon: "person",
    path: "/float-finance",
    Component: FloatFinance,
    forNav: true,
    hasAccess: true,
  },
  {
    name: "Float/Finance",
    icon: "person",
    path: "/float-finance/details/:id",
    Component: FloatDetails,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Agent/Update",
    icon: "person",
    path: "/update/agent/:id",
    Component: UpdateAgent,
    forNav: false,
    hasAccess: true,
  },

  {
    name: "Aggregators",
    icon: "person",
    path: "/trade-partners",
    Component: Aggregators,
    forNav: true,
    hasAccess: true,
  },
  {
    name: "New Aggregator",
    icon: "person",
    path: "/aggregator/new",
    Component: NewAggregators,
    forNav: false,
    hasAccess: true,
  },

  {
    name: "Agents Details",
    icon: "person",
    path: "/agents/details/:id",
    Component: AgentDetails,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Agents Details",
    icon: "person",
    path: "/agent/customers/:id",
    Component: AgentCustomers,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Create Agent",
    icon: "person",
    path: "/agents/new",
    Component: NewAgent,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Location",
    icon: "forum",
    path: "/location",
    Component: Location,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Location Details",
    icon: "forum",
    path: "/location/details/:id",
    Component: LocationDetails,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Loans",
    icon: "forum",
    path: "/loans",
    Component: POS,
    forNav: false,
    hasAccess: true,
  },

  {
    name: "Logs",
    icon: "settings_applications",
    path: "/logs",
    Component: Logs,
    forNav: true,
    hasAccess: true,
  },

  {
    name: "Logs Details",
    icon: "settings_applications",
    path: "/logs/details/:id",
    Component: LogsDetails,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Messages",
    icon: "mail_outline",
    path: "/messages",
    Component: POS,
    forNav: false,
    hasAccess: true,
  },

  {
    name: "Notifications",
    icon: "notifications",
    path: "/notifications",
    Component: Notifications,
    forNav: false,
    hasAccess: true,
  },
  {
    name: "Performance Chart",
    icon: "forum",
    path: "/performance",
    Component: PerformanceChart,
    forNav: true,
    hasAccess: true,
  },

  {
    name: "Settings & Support",
    icon: "settings",
    path: "/settings-and-support",
    Component: Settings,
    forNav: true,
    hasAccess: true,
  },
  {
    name: "Agent Terminals",
    icon: "settings",
    path: "/agent/terminals/:id",
    Component: AgentTerminals,
    forNav: false,
    hasAccess: true,
  },

  {
    name: "Agent Transactions",
    icon: "settings",
    path: "/agent/transactions/:id",
    Component: AgentTransactions,
    forNav: false,
    hasAccess: true,
  },
];
